<template>
  <div>
    <google-map :style="{ width: 'auto', height: height + 'px' }" :zoomLevel="getZoomLevel" ref="gMap" />
    <div v-if="showOpenPlaceList()" class="absolute inline-block -mt-6 h-10 text-center" :class="isMobile() ? 'w-full' : 'w-94'">
      <a @click="openPlaceList" class="inline-flex justify-center items-center px-4 h-6 bg-white rounded-t text-link shadow-sm">{{ $t('tour_search_place') }}</a>
    </div>
    <drawer @onRingoPass="onRingoPass" @closeMap="closeMap" />
    <location-button @getLocation="onGetLocation" />
    <busstop-menu />
    <div v-show="showRingoPassModal" class="h-full w-full pb-4">
      <ringo-pass
        @openRingoPass="openRingoPass"
        @closeRingoPass="closeRingoPass"
      />
    </div>
    <div v-if="$store.getters['drawer/getIsOpen'] && $store.getters['drawer/getIsFull']" class="absolute bg-white" :class="isMobile() ? 'w-full' : 'w-94'" :style="{ height: blank + 'px' }">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GoogleMap from './GoogleMap'
import LocationButton from '../../molecules/LocationButton'
import Drawer from './Drawer'
import BusstopMenu from './BusstopMenu'
import RingoPass from './RingoPass'
import Constants from "../../../constants"

export default {
  components: {
    GoogleMap,
    LocationButton,
    Drawer,
    BusstopMenu,
    RingoPass
  },
  props:{
    zoomLevel: {
      type: Number,
      required:false,
      default: 15
    }
  },
  data () {
    return {
      modal: {
        show: false,
        kind: 'error',
        target: undefined
      },
      windowHeight: window.innerHeight,
      showRingoPassModal: false,
      ringoPassUrl: null
    }
  },
  mounted () {
    window.addEventListener('resize', ()=>{
      this.windowHeight = window.innerHeight
    })
  },
  methods: {
    onGetLocation: function (location) {
      this.$store.dispatch('map/updateCenter', location)
    },
    openPlaceList: function () {
      this.$store.dispatch('map/recommendSearchCourse')
      this.$store.dispatch('drawer/open', { component: 'PlaceList' })
    },
    closeModal: function () {
      this.modal.show = false
    },
    showModal: function () {
      this.modal.show = true
    },
    showOpenPlaceList: function () {
      return Constants.ENABLED_MAP_SEARCH_PLACE
    },
    mapInitialized: function () {
      this.$refs.gMap.mapInitialized()
    },
    showRingoPass: function () {
      this.showRingoPassModal = false
    },
    onRingoPass: function (url) {
      this.ringoPassUrl = url
      this.showRingoPassModal = true
    },
    openRingoPass: function () {
      window.open(this.ringoPassUrl)
      this.showRingoPassModal = false
    },
    closeRingoPass: function () {
      this.showRingoPassModal = false
    },
    fitBoundsPlan: function () {
      this.$refs.gMap.fitBoundsPlan()
    },
    closeMap: function () {
      this.$emit('closeMap')
    },
    isMobile: function () {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("iphone") != -1 || userAgent.indexOf("android") != -1) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/getCenter'
    }),
    height: function () {
      const isOpen = this.$store.getters['drawer/getIsOpen']
      const isFull = this.$store.getters['drawer/getIsFull']
      // header: 48, foot: 45
      const h = this.windowHeight - (isOpen && isFull ? Math.floor(this.windowHeight * 2 / 3) : 48 + 45)
      this.$store.dispatch('map/updateHeight', h)
      return h
    },
    blank: function () {
      const isOpen = this.$store.getters['drawer/getIsOpen']
      const isFull = this.$store.getters['drawer/getIsFull']
      return isOpen && isFull ? this.windowHeight - this.height - 48 : 0
    },
    getZoomLevel() {
      return this.zoomLevel;
    }
  },
  watch: {
    center: function () {
      this.showPlaceList = false
    }
  }
}
</script>
